import { useEffect, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { refreshToken } from "../data/authenticationSlice"

const useTokenRefresher = () => {
    const dispatch = useDispatch()
    const timerId = useRef(null)

    useEffect(() => {
        refreshAccessToken()
    }, [])

    const initRefreshToken = () => {
        if (timerId.current) {
            clearTimeout(timerId.current)
        }
        timerId.current = setTimeout(() => {
            refreshAccessToken()
        }, 720000) // Call the Refresh API after 12 minutes
    }

    const refreshAccessToken = async () => {
        try {
            const token = window.sessionStorage.getItem("REFRESH_TOKEN")
            if (token) {
                const { payload } = await dispatch(refreshToken(token))
                if (payload?.succeeded) {
                    console.log({ payload })
                    window.sessionStorage.setItem("ACCESS_TOKEN", payload?.token)
                    window.sessionStorage.setItem("REFRESH_TOKEN", payload?.refreshToken)
                }
            }
        } catch (error) {
            console.error("Failed to refresh token", error)
        } finally {
            initRefreshToken()
        }
    }

    return {
        initRefreshToken
    }
}

export default useTokenRefresher
